/*
 * @Author: wangyy
 * @Date: 2020-12-23 13:40:35
 * @LastEditTime: 2020-12-23 14:00:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \路由改造\openplat-web\src\gtn\utils\user.js
 */
import Vue from 'vue'
import { setBehavior } from '@/api/login.js'
import router from '@/router'
import store from '@/store'
const goLoginUrl = (backUrl = window.location.href) => {
  // 给定一个默认参数，可以用来实现登录后跳转到新地址
  localStorage.setItem("backUrl", backUrl);
  const addressPre = window.LOCAL_CONFIG.ENV_URL;
  if (window.location.href.includes('.html')) {
    let userBehavior = backUrl
    setBehavior({ userBehavior }).then(() => {
      window.location.href = addressPre + '/login/login.html'
    })
  } else {
    window.location.href = addressPre + '/iuc/login?service=' + backUrl + '&login_type=2'
  }
}
// 注册
const registerFun = (backUrl = window.location.href) => {
  localStorage.setItem("backUrl", backUrl);
  if (window.location.href.includes('.html')) {
    let userBehavior = backUrl
    setBehavior({ userBehavior }).then(() => {
      window.location.href = '/login/login.html'
    })
  } else {
    window.location.href = '/iuc/register?service=' + backUrl
  }
}
const setHideNickName = res => {
  let nikeName = res['user'].nike_name
  if (nikeName) {
    //nikeName=$.trim(r.nikeName);
    if (
      /^1[3|4|5|7|8]\d{9}$/.test(nikeName) ||
      /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
        nikeName
      )
    ) {
      let str1 = nikeName.substring(0, 3)
      let str2 = nikeName.substring(nikeName.length - 4, nikeName.length)
      nikeName = str1 + '****' + str2
    }
  } else {
    nikeName = res['user'].hsid
    if (nikeName) {
      let str1 = nikeName.substring(0, 3)
      let str2 = nikeName.substring(nikeName.length - 4, nikeName.length)
      nikeName = str1 + '****' + str2
    }
  }
  res['user'].hideNickName = nikeName
}
const install = () => {
  Vue.prototype.$goLoginUrl = goLoginUrl
  Vue.prototype.$setHideNickName = setHideNickName
  Vue.prototype.$registerFun = registerFun
}
export default install



// WEBPACK FOOTER //
// ./src/gtn/utils/user.js